import { BehaviorSubject, Observable } from 'rxjs';

export class WantedLevelService {
    private readonly levelSubject = new BehaviorSubject<number>(0);
    readonly wantedLevel$: Observable<number> = this.levelSubject.asObservable();

    get wantedLevel(): number {
        return this.levelSubject.getValue();
    }

    set(level: number): void {
        const clamped = Math.max(0, Math.min(5, level));
        this.levelSubject.next(clamped);
    }

    increase(): void {
        this.set(this.wantedLevel + 1);
    }

    decrease(): void {
        this.set(this.wantedLevel - 1);
    }

    reset(): void {
        this.set(0);
    }

    resetWantedLevel(): void {
        this.reset();
    }
}
